import React, {Component} from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
import style from './Modales.css'
import api from '../../apiClient/v2'
import API from '../../apiClient/v1'

export class ModalTrigger extends Component{
    constructor(props){
        super(props)
        this.state = {
            visible: false
        }
        this.show = () => this.setState({visible: true})
        this.hide = () => this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export class ModalConfirmTotals extends Component{
    constructor(props){
        super(props)
        this.state = {
            continue: false,
            servicesNotApprove: this.props.data.servicesNotApprove
        }
        this.generate  = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            this.props.action().then(()=>{
                this.props.hideModal()
            })
                .catch(error=>{
                    console.log("error")
                })
        }
        this.handleSubmit = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({
                continue: !this.state.continue
            })
        }
        this.addCommentToService = (comment, idService) => {
            API.inv(idService).actualizarObservacion(comment)
                .then(() => {
                    console.log("se ha actualizado el comentario del servicio")    
                })
                .catch(error => console.log(error))
        }
        this.renderServiceNotApprove = () => {
            const {title, hideModal} = this.props
            return(
                <Modal show={true} onHide={hideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-row">
                                {this.state.servicesNotApprove.map((service) => (
                                    <TextAreaModal
                                        service={service}
                                        key={service.service_id}
                                        addCommentToService={this.addCommentToService}
                                    />
                                ))}
                            </div>
                            <div className="row">
                                <div className="col-sm-12 text-right">
                                    <button type="submit" className={`btn btn-success`}>Aceptar</button>
                                    <button type="button" className={`btn btn-warning`} onClick={this.props.hideModal}>Cancelar</button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )
        }
        this.renderConfirmTotals = () => {
            const {data, title, info, hideModal} = this.props
            return(
                <Modal show={true} onHide={hideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ul className="list-group">
                            <strong>Detalle</strong>
                            <li className="list-group-item">
                                <span className={'badge'}>{`${data.servicesApprove.length} de ${data.cantServices}`}</span>
                                Cantidad de servicios aprobados
                            </li>
                            <li className="list-group-item">
                                <span className={'badge'}>{data.totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                                Valor neto
                            </li>
                            <li className="list-group-item">
                                <span className={'badge'}>{data.iva.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                                Valor IVA
                            </li>
                            <li className="list-group-item">
                                <span className={'badge'}>{data.total.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                                Total
                            </li>
                        </ul>
                        <text className={style.ModalManagementOC_infoMsg}>{info}</text>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-success" onClick={(evt) => this.generate(evt)}>
                            Autorizar
                        </button>
                        <button className="btn btn-warning" onClick={hideModal}>
                            Cancelar
                        </button>
                    </Modal.Footer>
                </Modal>
            )
        }
    }
    render(){
        const {data} = this.props
        return (
            data.servicesNotApprove.length > 0 && !this.state.continue?
            this.renderServiceNotApprove() :
            this.renderConfirmTotals()
        )
    }
}

export class ModalCancelRequest extends Component{
    constructor(props){
        super(props)
        this.state = {
            visible: false,
            blockButton: false,
            comment: '',
        }
        this.onChangeComment = (evt) => {
            let comment = evt.target.value
            this.setState({comment})
        }
        this.handleSubmit = (evt) => {
            this.setState({blockButton: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.props.action(this.state.comment)
                .then(()=>{
                    this.setState({blockButton: false})
                    this.props.hideModal()
                })
                .catch(error=>{
                    console.log(error)
                })
        }
        this.renderWithServicesApprove = () => {
            return(
                <Modal show={true} onHide={this.props.hideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Rechazar solicitud orden de compra</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <text className={style.ModalManagementOC_infoMsg}>
                                No puede rechazar la solicitud si se encuentran servicios tickeados
                            </text>
                        </div>
                    </Modal.Body>
                </Modal>
            )
        }
        this.normalRender = () => {
            return(
                <Modal show={true} onHide={this.props.hideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Rechazar solicitud orden de compra</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <label>Debe indicar los motivos de su rechazo</label>
                                    <textarea className="form-control" placeholder="Indique aquí los motivos por el cual rechaza esta petición"
                                              value={this.state.comment}
                                              onChange={(evt) => this.onChangeComment(evt)}
                                              required
                                    />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 text-right">
                                        <button type="submit" className={`btn btn-success`}disabled={this.state.bloqueado}>Aceptar</button>
                                        <button type="button" className={`btn btn-warning`} onClick={this.props.hideModal}>Cancelar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <text className={style.ModalManagementOC_infoMsg}>Para su información sus motivos serán enviados via email a las partes implicadas</text>
                    </Modal.Body>
                </Modal>
            )    
        }
    }
    render(){
        return (
            this.props.isServicesApprove?
                this.renderWithServicesApprove() :
                this.normalRender()
        )
    }
}

export class ModalAssignNumberOC extends Component{
    constructor(props){
        super(props)
        this.state = {
            visible: false,
            blockButton: false,
            numberOC: '',
            filePDF: null
        }
        this.onChangeNumberOC = (evt) => {
            let numberOC = evt.target.value
            this.setState({numberOC : numberOC})
        }
        this.onChangeFile = (evt) => {
            let file = evt.target.files[0];
            this.setState({filePDF: file})
        }
        this.handleSubmit = (evt) => {
            this.setState({blockButton: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.props.action(this.state.numberOC, this.state.filePDF)
                .then(()=>{
                    this.setState({blockButton: false})
                    this.props.hideModal()
                })
                .catch(error=>{
                    console.log(error)
                })
        }
    }
    render(){
        const {data, title} = this.props
        return(
            <Modal show={true} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className="list-group">
                        <strong>Detalle</strong>
                        <li className="list-group-item">
                            <span className={'badge'}>{`${data.servicesApprove.length} de ${data.cantServices}`}</span>
                            Cantidad de servicios aprobados
                        </li>
                        <li className="list-group-item">
                            <span className={'badge'}>{data.totalNeto.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                            Valor neto
                        </li>
                        <li className="list-group-item">
                            <span className={'badge'}>{data.iva.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                            Valor IVA
                        </li>
                        <li className="list-group-item">
                            <span className={'badge'}>{data.total.toLocaleString("es-CL", { style: "currency", currency: "CLP"})}</span>
                            Total
                        </li>
                    </ul>
                    <div>
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label>Número orden de compra generado</label>
                                    <input type="number" className="form-control" placeholder="Número orden compra"
                                           value={this.state.numeroOC}
                                           onChange={(evt) => this.onChangeNumberOC(evt)}
                                           required
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Ajdunte PDF orden de compra</label>
                                    <input type="file" className="form-control-file" onChange={(evt) => this.onChangeFile(evt)} required/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 text-right">
                                    <button type="submit" className={`btn btn-success`}disabled={this.state.bloqueado}>Aceptar</button>
                                    <button type="button" className={`btn btn-warning`} onClick={this.props.hideModal}>Cancelar</button>                                    
                                </div>    
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>        
        )
    }
}

export class ModalAdminEmails extends Component{
    constructor(props){
        super(props)
        this.state = {
            emailsBilling: [],
            newEmail: '',
            newName: ''
        }
        this.getEmailsBilling = () => {
            api.client(this.props.idClient).getEmailsBilling()
                .then(response => {
                    this.setState({
                        emailsBilling: response,
                        newEmail: '',
                        newName: ''
                    })
                    
                })
                .catch(err => {})
        }
        this.addNewEmail = () => {
            if(this.state.newEmail=='' || this.state.newName=='')
                return
            api.client(this.props.idClient).addEmailBilling({
                email: this.state.newEmail,
                name: this.state.newName
            })
                .then(this.getEmailsBilling)
                .catch(meh => {})
        }
        this.deleteEmail = (idEmail) => {
            api.client(this.props.idClient).deleteEmailBilling(idEmail)
                .then(this.getEmailsBilling)
                .catch(meh => {})

        }
        this.onNewEmail = (evt) => {
            let email = evt.target.value
            this.setState({newEmail : email})
        }
        this.onNewName = (evt) => {
            let name = evt.target.value
            this.setState({newName: name})
        }
    }
    componentDidMount(){
        this.getEmailsBilling()
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Administra tus destinatarios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 className={style.ModalManagementOC_infoMsg}>Atención, las casillas que aparezcan en este listado serán incluidas como destinatarios en los procesos de correos automatizados.</h4>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <p className={style.ModalManagementOC_fixedWidth}><b>Correo</b></p>
                            <p className={style.ModalManagementOC_fixedWidth}><b>Nombre</b></p>
                        </li>
                        {this.state.emailsBilling.map(email=>
                            <li key={email.idEmail} className="list-group-item">
                                <p className={style.ModalManagementOC_fixedWidth}>{email.email}</p>
                                <p className={style.ModalManagementOC_fixedWidth}>{email.name}</p>
                                <button className="btn btn-xs btn-danger pull-right"
                                        onClick={() => this.deleteEmail(email.idEmail)}
                                >Eliminar</button>
                            </li>
                        )}
                        <li className="list-group-item">
                            <input type="text" 
                                   value={this.state.newEmail}
                                   onChange={this.onNewEmail}
                                   required
                                   onKeyDown={evt=>{ if(evt.keyCode==13) this.refName.focus() }}
                                   placeholder="nombre@email.com"
                            />
                            <input type="text"
                                   value={this.state.newName}
                                   ref={ref=>this.refName=ref}
                                   onChange={this.onNewName}
                                   required
                                   onKeyDown={evt=> { if(evt.keyCode==13) this.addNewEmail() }}
                                   placeholder="Juan Correa"
                            />
                            <button className="btn btn-xs btn-success pull-right"
                                onClick={this.addNewEmail}
                            >Agregar</button>
                        </li>
                    </ul>
                </Modal.Body>
            </Modal>
        )
    }
}

class TextAreaModal extends Component{
    constructor(props){
        super(props)
        this.state = {
            clientComment: this.props.service.client_comment
        }
        this.onChangeComment = (evt) => {
            let comment = evt.target.value
            this.setState({clientComment: comment})
        }
        this.onSaveComment = () => {
            this.props.addCommentToService(this.state.clientComment, this.props.service.service_id)
        }
    }
    render(){
        const {service} = this.props
        return(
            <div className="form-group">
                <label>{`${service.store_ceco} ${service.store_name}`}</label>
                <textarea
                    className="form-control"
                    value={this.state.clientComment}
                    onChange={(evt) => this.onChangeComment(evt)}
                    onBlur={this.onSaveComment}
                    placeholder="Indique motivo por el cual no aprueba este servicio" 
                    required
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/billing/management-oc/Modales.jsx